import { useBoardStore } from '@/stores/useBoardStore';

export function useBoardNodeFullscreenActive(): boolean {
  return useBoardStore(s => s.fullscreenNodeId != null);
}
